export enum UIDarstellungsart {
  DISABLED = 'Disabled',
  AUSGEBLENDET = 'Ausgeblendet',
  OHNE_EINSCHRAENKUNGEN = 'OhneEinschraenkung'
}
